export enum EnumModeloDeTrabalho {
    APENAS_CAIXA = "0",
    LANCADOR_COM_FECHAMENTO_DE_VENDAS = "1",
    LANCADOR_SEM_FECHAMENTO_DE_VENDAS = "2",
}